/* External dependencies */
import { AnyAction } from 'redux';

/* Local dependencies */
import { DeleteDeviceInput } from '../../types';

export enum DeleteDeviceActionTypes {
  DELETE_DEVICE_REQUEST = 'DELETE_DEVICE_REQUEST',
  DELETE_DEVICE_SUCCESS = 'DELETE_DEVICE_SUCCESS',
  DELETE_DEVICE_FAILURE = 'DELETE_DEVICE_FAILURE',
}

export interface DeleteDeviceAction extends AnyAction {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST;
  payload: DeleteDeviceInput;
}

export interface DeleteDeviceSuccessAction extends AnyAction {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_SUCCESS;
  payload: string; // success message
}

export interface DeleteDeviceFailureAction extends AnyAction {
  type: DeleteDeviceActionTypes.DELETE_DEVICE_FAILURE;
  payload: string;
}

export const deleteDeviceAction = (input: DeleteDeviceInput): DeleteDeviceAction => ({
  type: DeleteDeviceActionTypes.DELETE_DEVICE_REQUEST,
  payload: input,
});

export const deleteDeviceSuccess = (message: string): DeleteDeviceSuccessAction => ({
  type: DeleteDeviceActionTypes.DELETE_DEVICE_SUCCESS,
  payload: message,
});

export const deleteDeviceFailure = (error: string): DeleteDeviceFailureAction => ({
  type: DeleteDeviceActionTypes.DELETE_DEVICE_FAILURE,
  payload: error,
}); 